import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 运营顶栏 */}
      <div className="w-full bg-primary-700 text-background-50">
        <div className="mx-auto flex h-9 max-w-[1400px] items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-2 text-[12px] tracking-wide">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-open-source-line text-[13px]" />
            </span>
            <span>公开开放 · 无需付费 · 不限量观看</span>
          </div>
          <div className="hidden items-center gap-5 text-[12px] md:flex">
            <span className="flex items-center gap-1.5">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-refresh-line text-[13px]" />
              </span>
              今日已更新 128 条
            </span>
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap border border-background-50/40 px-3 py-0.5 text-[12px] transition-colors hover:bg-primary-600"
            >
              登录 / 收藏
            </button>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? 'border-background-300/70 bg-background-50/95 backdrop-blur'
            : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex h-[68px] max-w-[1400px] items-center justify-between gap-6 px-4 md:px-6">
          <h1 className="flex shrink-0 items-center">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-[22px]" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-[22px] font-black tracking-tight text-foreground-950">
                  黑料免费
                </span>
                <span className="mt-1 text-[11px] tracking-[0.22em] text-foreground-600">
                  OPEN · FREE · UNLIMITED
                </span>
              </span>
            </a>
          </h1>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-[14px] font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <div className="flex h-10 w-[210px] items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-[15px]" />
              </span>
              <input
                type="text"
                placeholder="搜索爆料关键词"
                className="w-full bg-transparent text-[13px] text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <a
              href="#submit"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              我要爆料
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <i className={menuOpen ? 'ri-close-line text-[20px]' : 'ri-menu-line text-[20px]'} />
          </button>
        </div>

        {/* 移动端菜单 */}
        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="cursor-pointer border-b border-background-200/70 py-3 text-[15px] font-medium text-foreground-800"
                >
                  {link.label}
                </a>
              ))}
            </nav>
            <div className="mt-4 flex h-11 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-[15px]" />
              </span>
              <input
                type="text"
                placeholder="搜索爆料关键词"
                className="w-full bg-transparent text-[14px] text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-3 block cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-[14px] font-medium text-background-50"
            >
              我要爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}